import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ErrorPage } from '@everfi/reactifi';
import CustomFavIcon from '../lib/CustomFavIcon';

const UserAssignments = lazy(() => import('./UserAssignments/index'));
const Registration = lazy(() => import('./Registration/index'));

function Student() {
  return (
    <>
      <CustomFavIcon />
      <Routes>
        <Route path="dashboard/*" element={<UserAssignments />} />
        <Route path="registration/*" element={<Registration />} />
        <Route path="*" element={<ErrorPage title="Page Not Found" />} />
      </Routes>
    </>
  );
}

export default Student;
